import lottie from "lottie-web";
import React, { useEffect, useRef } from "react";
import styles from "./ImageLoading.module.css";
import loader from "./assets/imageLoader.json";

const ImageLoading = ({ loading, style, showLabel = true, displayType = "" }) => {
  const lottieRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    if (lottieRef.current && loading) {
      animationRef.current = lottie.loadAnimation({
        animationData: loader,
        container: lottieRef.current,
      });

      return () => {
        animationRef.current.destroy();
      };
    }
  }, [lottieRef, loading]);

  if (loading !== true) return null;

  return (
    <div className={styles.loadingWrapper} style={style}>
      <div ref={lottieRef} className={styles.lottieLoader} />
      {showLabel && (
        <div className={styles.loadingText}>
          {displayType === "imageSearch" ? "Searching for an image" : "Generating an image"}
        </div>
      )}
    </div>
  );
};

export default ImageLoading;
